module.exports = __webpack_public_path__ + "static/img/logo_022.2823b178.png";